<mat-form-field class="question-form__dropdown" appearance="outline" [subscriptSizing]="'dynamic'">
  <mat-select
    [attr.aria-labelledby]="question().id"
    [formControl]="questionGrp().get('value') | toFormControl"
    aria-label="Select an answer"
    placeholder="Select an answer"
  >
    @for (option of visibleOptions$(); track option.value) {
      @if (question().useOtherInd && question().useOtherPosition === $index) {
        <ng-container *ngTemplateOutlet="other"></ng-container>
        <ng-container *ngTemplateOutlet="otherText"></ng-container>
      }

      <mat-option [value]="option.value">
        <span [innerHTML]="option.text"></span>
      </mat-option>

      @if (question().useOtherPosition >= visibleOptions$().length && $last) {
        <ng-container *ngTemplateOutlet="other"></ng-container>
        <ng-container *ngTemplateOutlet="otherText"></ng-container>
      }
    }
    <ng-template #other>
      <mat-option value="OTHER">{{ 'system.other' | translate }}</mat-option>
    </ng-template>
  </mat-select>
  <fa-icon matSuffix [icon]="faAnglesUpDown"></fa-icon>
</mat-form-field>

<ng-template #otherText>
  @if (this.questionGrp().get('value').value === 'OTHER') {
    <div class="question-form__input">
      <span class="label survey-viewer__html-content fs__sm fw__500" [innerHTML]="question().otherLabel"></span>
      <mat-form-field appearance="outline" class="eiq-survey-textarea">
        <textarea
          matInput
          [formControl]="questionGrp().get('otherText') | toFormControl"
          [required]="questionGrp().get('value').value === 'OTHER'"
          autocomplete="off"
        ></textarea>
      </mat-form-field>
    </div>
  }
</ng-template>
